import { SettingsSidebar } from "../../../../../externalComponents/SettingsSidebar";
import { PageHeading } from "../../../../../externalComponents/PageHeading";
import { OverflowFrame } from "../../../../../externalComponents";
import { Button } from "../../../../../externalComponents/tailwind/button";
import { useNavigate } from "react-router-dom";
import { Text } from "../../../../../externalComponents/tailwind/text";
import { useContext, useEffect, useRef } from "react";
import { CustomerContext } from "../../../../../providers";
import { api } from "../../../../../api";

export default function KlaviyoSuccessPage() {
  const navigate = useNavigate();
  const { customer } = useContext(CustomerContext);
  const urlParams = new URLSearchParams(window.location.search);
  const isSuccess = urlParams.get("success") === "true";
  const isDisconnected = urlParams.get("disconnected") === "true";
  const isError = urlParams.get("error") === "true";
  const shouldStart = urlParams.get("start") === "true";

  const hasOpenedRef = useRef(false);

  useEffect(() => {
    const launchConnexion = async () => {
      if (shouldStart && !hasOpenedRef.current) {
        hasOpenedRef.current = true;
        try {
          const installationUrl = await api.generateKlaviyoInstallationUrl({
            customerId: customer.id,
          });
          window.location.href = installationUrl;
        } catch (error) {
          console.error("Error connecting to Klaviyo:", error);
        }
      }
    };
    launchConnexion();
  }, [shouldStart, navigate]);

  return (
    <>
      <SettingsSidebar>
        <PageHeading title="Klaviyo integration" />
        <OverflowFrame>
          <div className="flex flex-col items-center justify-center h-full space-y-4">
            {shouldStart && (
              <Text className="text-center">
                Klaviyo connexion will start in a few seconds...
              </Text>
            )}
            {isSuccess && (
              <Text className="text-center">
                Your Klaviyo integration has been successfully set up!
              </Text>
            )}
            {isDisconnected && (
              <Text className="text-center">
                Your Klaviyo integration has been successfully removed!
              </Text>
            )}
            {isError && (
              <Text className="text-center">
                Authorization was declined. Please authorize access by clicking
                'Allow' to enable integration.
              </Text>
            )}
            <Button
              color="primaryButton"
              onClick={() => navigate("/settings/data/integrations")}
            >
              {isError ? "Try again" : "OK"}
            </Button>
          </div>
        </OverflowFrame>
      </SettingsSidebar>
    </>
  );
}
